import common from './common';
import stores from './stores';

export type IconName = keyof (typeof common & typeof stores);

export type IconScope = keyof typeof icons;

const icons = {
  common,
  stores,
};

export default icons;
